import React from 'react';
import { Check, Phone } from 'lucide-react';

import i18n from '../i18n';
import { useTranslation } from 'react-i18next';
const t = (k, o) => i18n.t(k, o);

const Card = ({ title, children }) => (
  <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 md:p-8">
    <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-4">{title}</h3>
    <div className="space-y-4 text-slate-600 dark:text-slate-300 leading-relaxed">{children}</div>
  </div>
);

const getbenefits = () => [
  t('pg.BarneMixSection.c0771f'),
  t('pg.BarneMixSection.a12d1c'),
  t('pg.BarneMixSection.e4ea06'),
  t('pg.BarneMixSection.b4218d'),
  t('pg.BarneMixSection.9a86c5'),
];

export const BarneMixSection = () => {
  useTranslation();
  return (
  <div className="space-y-8" data-testid="barnemix-section">
    <div className="bg-white dark:bg-slate-800 rounded-2xl border border-slate-200 dark:border-slate-700 overflow-hidden">
      <div className="aspect-video relative">
        <img
          src="/images/barnemix.jpg"
          alt={t('pg.BarneMixSection.70eddd')}
          loading="lazy"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
        <div className="absolute bottom-0 left-0 right-0 p-6">
          <h2 className="text-3xl font-bold text-white mb-2">{t('pg.BarneMixSection.a1fa9c')}</h2>
          <p className="text-white/80">{t('pg.BarneMixSection.0753a2')}</p>
        </div>
      </div>
    </div>

    <Card title={t('pg.BarneMixSection.9b33c5')}>
      <p>
        {t('pg.BarneMixSection.0671da')}
      </p>
      <p>
        {t('pg.BarneMixSection.d620bd')}
      </p>
    </Card>

    <Card title={t('pg.BarneMixSection.54c65e')}>
      <p>
        {t('pg.BarneMixSection.bf9cd4')}
      </p>
      <p>
        {t('pg.BarneMixSection.b0ffc6')}
      </p>
    </Card>

    <Card title={t('pg.BarneMixSection.ca917f')}>
      <p>{t('pg.BarneMixSection.bdfb70')}</p>
      <p>
        {t('pg.BarneMixSection.552479')}
      </p>
    </Card>

    <Card title={t('pg.BarneMixSection.30778b')}>
      <p>
        {t('pg.BarneMixSection.1a846d')}
      </p>
      <p>
        {t('pg.BarneMixSection.e80b2a')}
      </p>
    </Card>

    <Card title={t('pg.BarneMixSection.b8a7fb')}>
      <p>{t('pg.BarneMixSection.f4258d')}</p>
      <ul className="space-y-3">
        {getbenefits().map((item) => (
          <li key={item} className="flex items-start gap-2">
            <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" aria-hidden="true" />
            {item}
          </li>
        ))}
      </ul>
    </Card>

    <div className="bg-green-500/10 border border-green-500/30 rounded-xl p-6 md:p-8" data-testid="barnemix-goal">
      <p className="text-green-600 dark:text-green-400 font-bold text-lg text-center leading-relaxed">
        {t('pg.BarneMixSection.59c8ad')}
      </p>
    </div>

    <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6 text-center">
      <h3 className="text-xl font-bold text-slate-900 dark:text-white mb-2">{t('pg.BarneMixSection.f85347')}</h3>
      <a href="tel:90725152" className="inline-flex items-center gap-2 text-green-500 hover:underline text-xl font-bold">
        <Phone className="w-5 h-5" />
        90 72 51 52
      </a>
    </div>
  </div>
  );
};
